import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,hasClass,on,findIn, findAllIn} from '@elements/dom-utils';


const selectors = {
    base: '.js-table-slider',
    table: '.js-table-slider__table',
    slider: '.js-table-slider__slider',
    item: '.js-table-slider__item',
    arrowLeft: '.js-table-slider__arrow-left',
    arrowRight: '.js-table-slider__arrow-right',
};
const isMobile = matchMedia('(max-width: 767px)').matches || false;
const isTablet = matchMedia('(max-width: 1400px)').matches || false;

export function init() {
    onFind(selectors.base, function (baseElement) {
        let table = findIn(selectors.table, baseElement);
        let slider = findIn(selectors.slider, baseElement);
        let item = findAllIn(selectors.item, baseElement);
        let arrowLeft = findIn(selectors.arrowLeft, baseElement);
        let arrowRight = findIn(selectors.arrowRight, baseElement);

        if(isMobile){
            let width = item.length *  100;
            slider.setAttribute("style", "width:"+width+"%")
            let scrollAmount = item[0].offsetWidth;

            slideTable(item, 1, table, arrowLeft, arrowRight, scrollAmount);
        }else if(isTablet){
            let width = item.length *  33.33;
            slider.setAttribute("style", "width:"+width+"%")
            let scrollAmount = item[0].offsetWidth;

            slideTable(item, 3, table, arrowLeft, arrowRight, scrollAmount);
        }else {
            let width = item.length *  25;
            slider.setAttribute("style", "width:"+width+"%")
            let scrollAmount = item[0].offsetWidth;

            slideTable(item, 4, table, arrowLeft, arrowRight, scrollAmount);
        }
    });
}

function slideTable(item, limit, table, arrowLeft, arrowRight, scrollAmount){
    let counter = 0;

    if (item.length > limit) {
        on("click", function (event) {
            event.preventDefault();

            table.scrollLeft = table.scrollLeft - scrollAmount;
            counter--;

            if (counter === 0) {
                arrowLeft.setAttribute("disabled", true);
                arrowRight.removeAttribute("disabled");
            }else if (counter < 0 && arrowRight.hasAttribute("disabled")){
                arrowRight.removeAttribute("disabled");
            }

        }, arrowLeft);
        on("click", function (event) {
            event.preventDefault();

            table.scrollLeft = table.scrollLeft + scrollAmount;
            counter++;

            if (counter === item.length - limit) {
                arrowRight.setAttribute("disabled", true);
                arrowLeft.removeAttribute("disabled");
            }else if(counter < item.length - limit && arrowLeft.hasAttribute("disabled")){
                arrowLeft.removeAttribute("disabled");
            }
        }, arrowRight);
    } else {
        arrowRight.setAttribute("hidden", true);
        arrowLeft.setAttribute("hidden", true);
    }
}
